import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

// Debug utility to check and set Maria's permissions
export const checkMariaPermissions = async () => {
  try {
    // Find Maria's UID from the hardcoded list in UserManagement.js
    const mariaUID = 'MYxyZpTiMVONF5B7mQWiioXlDmk2';
    
    // Check current permissions
    const permissionRef = doc(db, 'instructorPermissions', mariaUID);
    const permissionSnap = await getDoc(permissionRef);
    
    if (permissionSnap.exists()) {
      const permissions = permissionSnap.data();
      console.log('Maria\'s current permissions:', permissions);
      return permissions;
    } else {
      console.log('No permissions document found for Maria');
      return null;
    }
  } catch (error) {
    console.error('Error checking Maria\'s permissions:', error);
    return null;
  }
};

// Helper function to assign Maria special access to scenario builder
export const assignMariaSpecialAccess = async () => {
  try {
    const mariaUID = 'MYxyZpTiMVONF5B7mQWiioXlDmk2';
    const permissionRef = doc(db, 'instructorPermissions', mariaUID);
    
    // Create permissions with special access to scenario builder
    const permissions = {
      generalAccess: [],
      specialAccess: ['scenarioBuilder'], // Use camelCase to match UserManagement.js
      lastUpdated: new Date(),
      updatedBy: 'test-utility'
    };
    
    await setDoc(permissionRef, permissions);
    console.log('✅ Maria\'s permissions updated:', permissions);
    alert('✅ Maria has been assigned special access to Scenario Builder! She should refresh her dashboard.');
    return permissions;
  } catch (error) {
    console.error('❌ Error updating Maria\'s permissions:', error);
    alert('❌ Error setting permissions: ' + error.message);
    return null;
  }
};

// Helper function to get Maria's actual UID from Firebase Auth
export const findMariaActualUID = async () => {
  try {
    const { db } = await import('../firebase.js');
    const { collection, getDocs, query, where } = await import('firebase/firestore');
    
    // Search for Maria by email in the users collection
    const usersRef = collection(db, 'users');
    const q = query(usersRef, where('email', '==', 'msepulveda8@ccc.edu'));
    const querySnapshot = await getDocs(q);
    
    if (!querySnapshot.empty) {
      const userDoc = querySnapshot.docs[0];
      const actualUID = userDoc.id;
      const userData = userDoc.data();
      
      console.log('📋 Found Maria in users collection:');
      console.log('- Actual UID:', actualUID);
      console.log('- User Data:', userData);
      console.log('- Expected UID:', 'MYxyZpTiMVONF5B7mQWiioXlDmk2');
      console.log('- UIDs Match:', actualUID === 'MYxyZpTiMVONF5B7mQWiioXlDmk2');
      
      return { actualUID, userData };
    } else {
      console.log('❌ Maria not found in users collection');
      return null;
    }
  } catch (error) {
    console.error('❌ Error finding Maria:', error);
    return null;
  }
};

// Enhanced assign function that uses the actual UID
export const assignMariaSpecialAccessWithActualUID = async () => {
  try {
    const mariaInfo = await findMariaActualUID();
    if (!mariaInfo) {
      alert('Could not find Maria in the database');
      return null;
    }
    
    const { actualUID } = mariaInfo;
    const { db } = await import('../firebase.js');
    const { doc, setDoc } = await import('firebase/firestore');
    
    const permissionRef = doc(db, 'instructorPermissions', actualUID);
    
    // Create permissions with special access to scenario builder
    const permissions = {
      generalAccess: [],
      specialAccess: ['scenarioBuilder'], // Use camelCase to match UserManagement.js
      lastUpdated: new Date(),
      updatedBy: 'debug-utility-with-actual-uid'
    };
    
    await setDoc(permissionRef, permissions);
    console.log('✅ Maria\'s permissions updated with actual UID:', permissions);
    alert('✅ Maria has been assigned special access using her actual UID! She should refresh her dashboard.');
    return permissions;
  } catch (error) {
    console.error('❌ Error updating Maria\'s permissions:', error);
    alert('❌ Error setting permissions: ' + error.message);
    return null;
  }
};

// Debug function to call from browser console
window.debugMaria = {
  check: checkMariaPermissions,
  assign: assignMariaSpecialAccess,
  findActualUID: findMariaActualUID,
  assignWithActualUID: assignMariaSpecialAccessWithActualUID
};

console.log('🔧 Maria debug utilities loaded!');
console.log('Maria Expected UID: MYxyZpTiMVONF5B7mQWiioXlDmk2');
console.log('Maria Email: msepulveda8@ccc.edu');
console.log('Commands:');
console.log('- await window.debugMaria.findActualUID() - find Maria\'s real UID');
console.log('- await window.debugMaria.assignWithActualUID() - assign using real UID');
console.log('- await window.debugMaria.check() - check current permissions');

// Also expose the UID for easy access
window.mariaUID = 'MYxyZpTiMVONF5B7mQWiioXlDmk2';
